import { render, staticRenderFns } from "@/components/Layout/Menu/Administracion/Administracion_ayudantes/Administracion_ayudantes.html?vue&type=template&id=5e22ab4d&scoped=true&"
import script from "@/components/Layout/Menu/Administracion/Administracion_ayudantes/Administracion_ayudantes.js?vue&type=script&lang=js&"
export * from "@/components/Layout/Menu/Administracion/Administracion_ayudantes/Administracion_ayudantes.js?vue&type=script&lang=js&"
import style0 from "@/components/Layout/Menu/Administracion/Administracion_ayudantes/Administracion_ayudantes.css?vue&type=style&index=0&id=5e22ab4d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e22ab4d",
  null
  
)

export default component.exports